/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.reviews.rpc.ReviewsRpc
 */

/**
 * Virtual record for map with known enum keys
 */

/**
 * Virtual record for map with known enum keys
 */

export let ComHubspotReviewsModelsAbstractGenerateTitleError;
(function (_ComHubspotReviewsModelsAbstractGenerateTitleError) {})(ComHubspotReviewsModelsAbstractGenerateTitleError || (ComHubspotReviewsModelsAbstractGenerateTitleError = {}));
export let ComHubspotReviewsModelsAbstractGetStatsBatchError;
(function (_ComHubspotReviewsModelsAbstractGetStatsBatchError) {})(ComHubspotReviewsModelsAbstractGetStatsBatchError || (ComHubspotReviewsModelsAbstractGetStatsBatchError = {}));
export let ComHubspotReviewsModelsAbstractGetSummaryError;
(function (_ComHubspotReviewsModelsAbstractGetSummaryError) {})(ComHubspotReviewsModelsAbstractGetSummaryError || (ComHubspotReviewsModelsAbstractGetSummaryError = {}));
export let ComHubspotReviewsModelsThemesAbstractGetThemesError;
(function (_ComHubspotReviewsModelsThemesAbstractGetThemesError) {})(ComHubspotReviewsModelsThemesAbstractGetThemesError || (ComHubspotReviewsModelsThemesAbstractGetThemesError = {}));
export const generateTitleRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'generateTitle',
  auth: 'external',
  fingerprint: '4q5ENcDulonmxBCl8KDHlJG0DHPqwZAw',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSummaryRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getSummary',
  auth: 'external',
  fingerprint: 'w4ShM0OOxZaic1v6FGKGHm5znO6Jte-P',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getStatsBatchRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getStatsBatch',
  auth: 'external',
  fingerprint: 'loajtGqFCIgCURFkNIRBfLj11ZV1D9k0',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getThemesRpc = {
  serviceName: 'com.hubspot.reviews.rpc.ReviewsRpc',
  rpcName: 'getThemes',
  auth: 'external',
  fingerprint: 'fMDThFkFbqwnKDiSpQZsP-C6RBaWvYMU',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};